import { useEffect } from 'react';
import { ui } from '@procuros/datachecks';

import { SuggestionNavigationServiceSingleton } from '.';
import { useSuggestionChangesWorker } from './useSuggestionChangesWorker';

export const useSuggestionChanges = (
  baseData: Record<string, unknown> | undefined,
  revisedData: Record<string, unknown> | undefined,
  uiConfig: Array<ui.Section> | undefined,
): number => {
  const items = useSuggestionChangesWorker(baseData, revisedData, uiConfig);

  useEffect(() => {
    SuggestionNavigationServiceSingleton.setItems(items);
    SuggestionNavigationServiceSingleton.focusOnCurrentItem();

    return () => {
      SuggestionNavigationServiceSingleton.clearItems();
    };
  }, [items]);

  return items.length;
};
